export default __webpack_public_path__ + "static/media/object--cctv-camera.2eea74b0.png";